import { getAppLocale } from '../../../utils/app-locale';
import { LICENSE_MODELS, api_base_url } from '../../../constants';
import { API_INSTANCE } from '../../../utils/service-http';
import ProductInformationCache from '../../../persistence/description-cache';
import { appConfiguration } from '../../../utils/app-starter';

export function getLicenceCategories (softwareSelection, licenseModel = LICENSE_MODELS.PERPETUAL) {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

  return API_INSTANCE.post(`${api_base_url}/software-licence-groups?locale=${getAppLocale()}${mainOverrideString}`, {
    softwareSelection,
    licenseModel
  }).then((success) => {
    return success.data.payload;
  }).catch((error) => {
    throw error;
  });
}

function extractReplacableLicenceIds (payload) {
  return payload.steps?.flatMap(step => [...(step.questionGroups || [])])
    .flatMap(questionGroup => [...(questionGroup.questions || [])])
    .flatMap(question => [...(question.answers || [])])
    .flatMap(answer => [...(answer.updateMapping || [])])
    .flatMap(mappingRow => mappingRow.previousLicence);
}

export function getLicenceSelectorQuestions (softwareSelection, licenceType) {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

  return API_INSTANCE.post(`${api_base_url}/software-licence-selector-questions?locale=${getAppLocale()}${mainOverrideString}`, {
    softwareSelection, licenceType
  }).then((success) => {

    ProductInformationCache.loadReferencesDescriptions([
      ...success.data.payload.formulas.map(formula => formula.id),
      ...extractReplacableLicenceIds(success.data.payload)
    ]);
    return success.data.payload;
  }).catch((error) => {
    throw error;
  });
}
